import { type RefObject, useLayoutEffect, useState } from 'react';

type TableRowsLimitOptions = {
    headerHeight: number;
    maxLimit: number;
    rowGap: number;
    rowHeight: number;
};

export const useInitialTableRowsLimit = (
    tableViewportRef: RefObject<HTMLElement | null>,
    { headerHeight, maxLimit, rowGap, rowHeight }: TableRowsLimitOptions
) => {
    const [limit, setLimit] = useState<number | null>(null);

    useLayoutEffect(() => {
        const tableViewport = tableViewportRef.current;

        if (!tableViewport) {
            return;
        }

        const tableBodyHeight = Math.max(tableViewport.clientHeight - headerHeight, 0);
        const rowsCount = Math.floor((tableBodyHeight + rowGap) / (rowHeight + rowGap));

        setLimit(Math.min(Math.max(rowsCount, 1), maxLimit));
    }, [headerHeight, maxLimit, rowGap, rowHeight, tableViewportRef]);

    return limit;
};
